<template>
  <div :class="type" class="mt-4">
    <b-field label="Exp. Month / Year">
    <div class="columns is-gapless is-mobile mb-0" >

      <div class="column is-narrow mr-3" :class="type">

          <b-select placeholder="M" required v-model="month" @input="setType">
            <option v-for="option in cardExpMonthOptions" :value="option" :key="option"> {{ option }} </option>
          </b-select>

      </div>
        <div class="column" :class="type">
          <b-select placeholder="Y" required v-model="year" @input="setType">
              <option v-for="option in cardExpOptions" :value="option" :key="option"> {{ option }} </option>
          </b-select>
          </div>


    </div>
      </b-field>
    <span :class="type" class="has-text-danger" v-if="message">{{ message }}</span>
  </div>
</template>
<script>

  export default {
      name: 'creditCardExpirationInput',
      data() {
        return {
          type: null,
          message: '',
          date: null,
          month: '',
          year: '',
        }
      },
      methods: {
        setType() {
          // JK: This date is set to the first day of the month after the expiration date
          // since the card will be valid for the whole month listed on the card
          // Ex: Expires 07/21, the card should still work for the whole month of July
          var date = new Date(this.year, this.month)
          this.date = date
          var today = new Date()

          if (date > today) {
            this.type = ''
            this.$emit('input', {year: this.year, month: this.month})
            this.message=null
          }
          else {
            this.type = 'has-background-danger-light'
            this.message = 'Invalid Date'
            this.$emit('input',  null)
          }

        },
        clearType() {
          this.message = null
          this.$emit('input',  null)
        },

      },
      computed: {
        cardExpOptions() {
          var current = new Date().getFullYear()
          var options = []
          for (let x = 0; x < 21; x++) {
            options.push(current + x)
          }
          return options
        },
        cardExpMonthOptions() {
          var current = 1
          var options = []
          for (let x = 1; x <= 12; x++) {
            options.push(x)
          }
          return options
        },
      }
  }
</script>
